import React from "react";
import {API_URL} from "../../settings/local_settings";
import {Spinner} from "../Spinner";
import {EditElementModalForm} from "../EditElementModalForm";
import BudgetValueInput from "../elements/BudgetValueInput";
import {APIClient} from "../../utils/APIClient";
import BudgetPartialGoalsConfiguration from "../elements/BudgetPartialGoalsConfiguration";
import {BudgetHelper} from "../../utils/BudgetHelper";
import {BU_PERIOD_PERIODIC, getBuPeriodName} from "../../periods";
import ScheduleConfiguration from "../elements/ScheduleConfiguration";
import moment from "moment/moment";
import {ItemPeriodDates} from "../../utils/ItemPeriodDates";
import {ItemScheduleConfiguration} from "../../utils/ItemScheduleConfiguration";
import { withTranslation } from 'react-i18next';

class EditPeriodDatesFormComponent extends EditElementModalForm {

    constructor(props) {
        super(props);
        this.state = {
            clientName: this.props.clientName,
            businessUnitName: this.props.businessUnitName !== undefined ? this.props.businessUnitName: null,
            campaignName: null,
            adgroupName: null,
            itemPeriodDates: this.props.itemPeriodDates,
            loading: true,
            saving: false
        };

        this.handleItemScheduleConfigurationChange = this.handleItemScheduleConfigurationChange.bind(this);
    }

    componentDidMount() {
        if(this._isEditingCampaign())
            this.getCampaignPeriodDatesData();
        else if(this._isEditingAdgroup())
            this.getAdgroupPeriodDatesData();
        else
            this.getBusinessUnitPeriodDates();
    }

    getCampaignPeriodDatesData() {
        throw new Error("Method not implemented.");
    }

    getAdgroupPeriodDatesData() {
        throw new Error("Method not implemented.");
    }

    getBusinessUnitPeriodDates() {
        new APIClient(this.getBusinessUnitDataUrl()).call('GET').then((response) => {
            if (response.status === 'ERROR') {
                alert(response.error_message);
            } else if (response.status === 'OK') {
                const itemPeriodDates = this.state.itemPeriodDates;
                itemPeriodDates.setItemScheduleConfiguration(new ItemScheduleConfiguration(response.data.item_schedule_configuration));
                this.setState({
                    itemPeriodDates: itemPeriodDates,
                    loading: false
                });
            }
        })
    }

    getBusinessUnitDataUrl() {
        return API_URL + `business-unit/${this.props.businessUnitId}/modify-period-dates/`;
    }

    handleItemScheduleConfigurationChange(itemScheduleConfiguration) {
        const itemPeriodDates = this.state.itemPeriodDates;
        itemPeriodDates.setItemScheduleConfiguration(itemScheduleConfiguration);
        this.setState({...this.state, itemPeriodDates: itemPeriodDates});
    }

    getSubmitUrl() {
        if(this._isEditingCampaign())
            return this.getCampaignUrl()
        else if(this._isEditingAdgroup())
            return this.getAdgroupUrl()
        else
            return API_URL + `business-unit/${this.props.businessUnitId}/modify-period-dates/`;
    }

    getCampaignUrl() {
        return API_URL + `campaigns-configurations/${this.props.campaignsConfigurationId}/modify-period-dates/${this.props.campaignId}/`;
    }

    getAdgroupUrl() {
        return API_URL + `campaigns-configurations/${this.props.campaignsConfigurationId}/modify-period-dates/${this.props.adgroupId}/`;
    }

    getDataToSubmit(event) {
        return {
            'period_dates_data': this.state.itemPeriodDates.data()
        };
    }

    renderSaveButton() {
        if (this.state.saving === false) {
            const { t } = this.props;
            return <input type="submit" value={t('client.save_button')} className="btn -submit"/>
        } else {
            return <Spinner color="positive small"/>;
        }
    }

    renderFormFields() {
        const { t } = this.props;
        if (this.state.loading === true) {
            return <Spinner color="positive small"/>;
        }

        return <div className="modal-section">
            <div className="row mb-3 pb-0">
                <div className="col-6">
                    <label>{t('edit_period_dates_form.client')}</label>
                    <input name="client" type="text" value={this.state.clientName} readOnly="readonly"
                           className="form-control"/>
                </div>
                {this.renderBusinessUnitName()}
            </div>
            {this.renderCampaignAndAdgroupNameRow()}
            <div className="row mb-3 pb-0">
                <div className="col-6">
                    <label>{t('edit_period_dates_form.period')}</label>
                    <input name="period" type="text"
                           value={getBuPeriodName(this.props.itemPeriodDates.periodType(), t)} readOnly="readonly"
                           className="form-control"/>
                </div>

                {/*{this.renderPeriodDates()}*/}
            </div>
            <div className="row mt-5 pb-0 mb-0">
                <div className="col-12">
                    <div key="schedule-configuration" className="row">
                        <div className="col-md-12 pl-0">
                            <ScheduleConfiguration onChange={this.handleItemScheduleConfigurationChange}
                                                   itemScheduleConfiguration={this.props.itemPeriodDates.itemScheduleConfiguration()}/>
                        </div>
                    </div>
                </div>

                {/*<div className="col-12">*/}
                {/*    <label>Período</label>*/}
                {/*</div>*/}
                {/*<div className="row col-12">*/}
                {/*    <div className="form-col">*/}
                {/*        <BudgetValueInput currencyReadOnly={true}*/}
                {/*                          onAmountChange={this.handleAmountChange}*/}
                {/*                          budgetCurrency={this.state.budgetCurrency}*/}
                {/*                          budgetAmount={this.state.budgetAmount}*/}
                {/*        />*/}
                {/*    </div>*/}
                {/*    <div className={"form-col"}></div>*/}
                {/*</div>*/}
                {/*<div className="row col-12">*/}
                {/*    <BudgetPartialGoalsConfiguration*/}
                {/*        enabled={(this.state.budgetPartialGoals !== null && this.state.budgetPartialGoals !== undefined && this.state.budgetPartialGoals.length > 0)}*/}
                {/*        budgetPeriodType={this.props.budgetPeriodType}*/}
                {/*        budgetFromDate={this.props.budgetFromDate}*/}
                {/*        budgetToDate={this.props.budgetToDate}*/}
                {/*        budgetPartialGoals={this.state.budgetPartialGoals}*/}
                {/*        onChange={this.handleBudgetPartialGoalsChange}*/}
                {/*        budgetTotalAmount={this.state.budgetAmount}*/}
                {/*    />*/}
                {/*</div>*/}
            </div>
        </div>;
    }

    // renderPeriodDates() {
    //     if (this.props.itemPeriodDates.periodType() === BU_PERIOD_PERIODIC) {
    //         // Este feature se escondió porque no se viene usando
    //         if(this.props.itemPeriodDates.firstDay() === 1)
    //             return null;
    //         return (
    //             <div className="form-col">
    //                 <label>Día de inicio de período</label>
    //                 <input name="first-day" type="text" value={this.props.itemPeriodDates.firstDay()} readOnly="readonly"
    //                        className="form-control"/>
    //             </div>
    //         )
    //     } else {
    //         return (
    //             <div className="form-col">
    //                 <label>Fechas</label>
    //                 <div className="period-date-picker-edit">
    //                     <DateRangePicker
    //                         startDate={moment(this.state.periodFirstDate, 'YYYY-MM-DD')} // momentPropTypes.momentObj or null,
    //                         isOutsideRange={this.dayIsInvalid}
    //                         startDateId="your_unique_start_date_id" // PropTypes.string.isRequired,
    //                         endDate={moment(this.state.periodLastDate, 'YYYY-MM-DD')} // momentPropTypes.momentObj or null,
    //                         endDateId="your_unique_end_date_id" // PropTypes.string.isRequired,
    //                         onDatesChange={this.handleSelectedTemporalRangeDefinition} // PropTypes.func.isRequired,
    //                         focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
    //                         onFocusChange={focusedInput => this.setState({focusedInput: focusedInput})} // PropTypes.func.isRequired,
    //                         minimumNights={0}
    //                         displayFormat="DD MMM YYYY"
    //                         noBorder={true}
    //                     />
    //                 </div>
    //             </div>
    //         )
    //     }
    // }

    renderBusinessUnitName() {
        const { t } = this.props;
        if (!this.state.businessUnitName)
            return null;

        return <div className="col-6">
            <label>{t('edit_period_dates_form.business_unit')}</label>
            <input name="business_unit" type="text" value={this.state.businessUnitName} readOnly="readonly"
                   className="form-control"/>
        </div>;
    }

    renderCampaignAndAdgroupNameRow() {
        const { t } = this.props;
        if(!this._isEditingCampaign() && !this._isEditingAdgroup())
            return null;

        let adgroupSection = "";
        if(this._isEditingAdgroup()) {
            adgroupSection = <div className="col-6">
                                <label>{t('edit_period_dates_form.adgroup')}</label>
                                <input name="adgroup" type="text" value={this.state.adgroupName} readOnly="readonly"
                                       className="form-control"/>
                            </div>;
        }

        return <div className="row mb-3 pb-0">
            <div className="col-6">
                <label>{t('edit_period_dates_form.campaign')}</label>
                <input name="campaign" type="text" value={this.state.campaignName} readOnly="readonly" className="form-control"/>
            </div>
            {adgroupSection}
        </div>
    }

    _isEditingCampaign() {
        return this.props.campaignsConfigurationId !== undefined
            && this.props.campaignsConfigurationId !== null
            && this.props.campaignId !== undefined
            && this.props.campaignId !== null;
    }

    _isEditingAdgroup() {
        return this.props.campaignsConfigurationId !== undefined
            && this.props.campaignsConfigurationId !== null
            && this.props.adgroupId !== undefined
            && this.props.adgroupId !== null;
    }


}

export const EditPeriodDatesForm = withTranslation()(EditPeriodDatesFormComponent);
